var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodingPana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.56,408.9c-15.55-10.87-19.08-31-18.46-49.16.1-3-.23-6.22,1.21-8.87s4.8-4.47,7.51-3.2c2.24,1.06,3.22,3.67,4.48,5.84a17.72,17.72,0,0,0,7.1,6.77c1.93,1,4.31,1.62,6.21.57,2.61-1.44,2.92-5.05,2.9-8.06q0-8.42-.1-16.83a28.2,28.2,0,0,1,.9-8.94c.94-2.85,3-5.51,5.87-6.31s6.41.85,7,3.8a29.06,29.06,0,0,1,.09,3.74c.08,1.25.66,2.64,1.85,3s2.4-.5,3.3-1.38c3.11-3,5.22-7,7.19-10.85s3.88-7.87,6.7-11.19,6.72-5.94,11-6.18,8.9,2.41,10,6.64-1.38,8.55-4.08,12a67,67,0,0,1-14,13.33,5.58,5.58,0,0,0-2.34,2.52c-.65,2,1.25,4,3.23,4.66,2.25.74,4.68.51,7,.79s4.89,1.31,5.77,3.53c1.24,3.07-1.34,6.3-3.87,8.41a57.42,57.42,0,0,1-17,9.83c-2.21.81-4.54,1.52-6.33,3.08s-2.86,4.26-1.78,6.38,3.84,2.8,6.16,2.37,4.4-1.69,6.61-2.53c4.13-1.56,9.48-1.27,12.12,2.3a9.51,9.51,0,0,1,1,8.43,22,22,0,0,1-4.56,7.43,57.92,57.92,0,0,1-24.71,17.37c-9.6,3.33-18.49,4.23-28,.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33,422.34a132.19,132.19,0,0,1,4.91-24.81,270.76,270.76,0,0,1,10.71-29l3.2-7.47c1.05-2.45,2.1-4.87,3.27-7.19A134.37,134.37,0,0,1,409.9,341c2.58-4,5.17-7.68,7.62-11.11s4.81-6.58,7.08-9.36a106,106,0,0,1,11.65-12.32c1.48-1.35,2.67-2.35,3.48-3l.93-.75a1.51,1.51,0,0,1,.33-.24,2.44,2.44,0,0,1-.29.28l-.89.8c-.79.7-2,1.72-3.42,3.09a113.24,113.24,0,0,0-11.49,12.41c-2.24,2.79-4.57,5.94-7,9.38s-5,7.13-7.56,11.12a136.13,136.13,0,0,0-7.43,12.86c-1.16,2.3-2.19,4.71-3.25,7.17l-3.19,7.46a276.22,276.22,0,0,0-10.73,29,134.48,134.48,0,0,0-5,24.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.58,353.82a5.93,5.93,0,0,1-.3-1.28c-.16-.83-.34-2-.56-3.54-.42-3-.87-7.16-1.34-11.74s-1-8.73-1.45-11.71c-.23-1.5-.43-2.7-.58-3.53a6.26,6.26,0,0,1-.17-1.31,5.8,5.8,0,0,1,.38,1.26c.21.82.47,2,.75,3.51.57,3,1.14,7.12,1.62,11.72s.87,8.62,1.18,11.75c.15,1.41.28,2.6.39,3.56A7.53,7.53,0,0,1,402.58,353.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.27,346.59a8.67,8.67,0,0,1-1.54.19c-1,.08-2.43.2-4.2.41-3.55.38-8.42,1.08-13.77,2.09s-10.15,2.14-13.6,3.06c-1.72.44-3.11.84-4.07,1.11a7.33,7.33,0,0,1-1.51.37,8.65,8.65,0,0,1,1.44-.58c1-.33,2.32-.79,4-1.28,3.43-1,8.23-2.21,13.6-3.23a135.75,135.75,0,0,1,13.83-1.93c1.78-.16,3.23-.22,4.23-.24A7.76,7.76,0,0,1,441.27,346.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,396.82s-.11-.15-.26-.47l-.67-1.4c-.57-1.22-1.34-3-2.28-5.22-1.86-4.43-4.25-10.64-6.79-17.52s-4.87-13.1-6.64-17.57L367,349.36c-.23-.58-.42-1.05-.57-1.44a1.93,1.93,0,0,1-.16-.52,1.81,1.81,0,0,1,.26.47l.67,1.4c.56,1.22,1.34,3,2.27,5.22,1.87,4.44,4.26,10.64,6.8,17.52s4.86,13.11,6.64,17.57l2.11,5.28c.23.58.41,1.06.57,1.45A2.06,2.06,0,0,1,385.72,396.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,380.25a1.9,1.9,0,0,1-.51.21l-1.49.5-5.51,1.79c-4.65,1.5-11.05,3.66-18.11,6.05s-13.49,4.49-18.17,5.91c-2.35.7-4.24,1.26-5.56,1.61l-1.53.4a1.68,1.68,0,0,1-.54.1,2.12,2.12,0,0,1,.51-.21l1.49-.5,5.51-1.78c4.65-1.51,11-3.67,18.11-6.06s13.49-4.49,18.17-5.9c2.35-.71,4.25-1.26,5.57-1.62l1.52-.4A2.13,2.13,0,0,1,437.14,380.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.4,332.46a4,4,0,0,1-.4-.59l-1-1.61c-.84-1.38-2-3.32-3.4-5.65l.31.08L450,329.32c0,.07.18-.68.09-.36h0l0,0,0,.07.08.13.15.28.32.54.61,1.06,1.18,2.06,2.15,3.77-.31-.08c2.36-1.33,4.35-2.43,5.77-3.2l1.67-.89a3.31,3.31,0,0,1,.64-.31,4.67,4.67,0,0,1-.51.35l-1.57,1c-1.36.84-3.35,2.05-5.77,3.47l-.2.11-.11-.19c-.68-1.16-1.42-2.42-2.19-3.75l-1.2-2.05-.61-1.06-.32-.54-.15-.28-.08-.13,0-.07,0,0v0h0c-.08.32.12-.43.1-.35l8-4.57.19-.11.11.19c1.39,2.44,2.51,4.49,3.27,5.89.35.65.64,1.18.87,1.63A2.53,2.53,0,0,1,462.4,332.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.31,
    y: 64.53,
    width: 9.67,
    height: 48.12,
    transform: "translate(-0.47 0.84) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.47,
    y: 64.69,
    width: 25.05,
    height: 26.57,
    transform: "translate(-0.42 0.43) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.39,
    y: 64.56,
    width: 25.05,
    height: 26.57,
    transform: "translate(-0.42 0.56) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.44,72.1c16.64.14,33.33,0,50-.23a.27.27,0,0,0,0-.53c-16.64-.09-33.33,0-50,.3a.23.23,0,0,0,0,.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.84,
    y: 90.87,
    width: 45.5,
    height: 21.65,
    transform: "translate(-0.54 0.4) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.13,
    y: 90.63,
    width: 45.5,
    height: 21.65,
    transform: "translate(-0.54 0.64) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.81,97c30.23.34,60.57,0,90.79-.45a.27.27,0,0,0,0-.53c-30.23-.16-60.57-.14-90.79.52a.23.23,0,0,0,0,.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 112.65,
    width: 176.29,
    height: 7.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.66,
    y: 116.38,
    width: 7.16,
    height: 26.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.49,
    y: 116.38,
    width: 7.16,
    height: 26.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.8,
    y: 46.58,
    width: 9.67,
    height: 66.19,
    transform: "translate(-0.42 0.89) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.52,
    y: 58.92,
    width: 15.03,
    height: 53.64,
    transform: "translate(-0.46 0.96) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,69.21a53.25,53.25,0,0,1-7.51.26,53.45,53.45,0,0,1-7.52-.26,55.33,55.33,0,0,1,7.52-.26A55.12,55.12,0,0,1,185.3,69.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,67a55.12,55.12,0,0,1-7.51.26,55.33,55.33,0,0,1-7.52-.26,53.45,53.45,0,0,1,7.52-.26A53.25,53.25,0,0,1,185.3,67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,104.44a52.28,52.28,0,0,1-7.51.27,52.48,52.48,0,0,1-7.52-.27,55.33,55.33,0,0,1,7.52-.26A55.12,55.12,0,0,1,185.3,104.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3,102.19a53.25,53.25,0,0,1-7.51.26,53.45,53.45,0,0,1-7.52-.26,55.33,55.33,0,0,1,7.52-.26A55.12,55.12,0,0,1,185.3,102.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,97.28c-.14,0-.26-5.42-.26-12.09s.12-12.09.26-12.09.26,5.41.26,12.09S178.17,97.28,178,97.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.46,
    y: 72.05,
    width: 16.36,
    height: 40.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.11,102a3.52,3.52,0,0,1-3.66-3.65,3.17,3.17,0,0,1,1.32-2.73l.38.51a2.65,2.65,0,0,0-1.08,2.22,3,3,0,0,0,6.07,0,2.62,2.62,0,0,0-1.08-2.22l.38-.51a3.2,3.2,0,0,1,1.32,2.73A3.52,3.52,0,0,1,194.11,102Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84,94.66l-.56-.32a4.17,4.17,0,0,0,.87-2.59c0-1.52-.53-2.13-1.35-2.13-2.09,0-.55,4.78-3.38,4.78-1.09,0-2-.91-2-2.74a4.44,4.44,0,0,1,.7-2.46l.56.31a3.68,3.68,0,0,0-.65,2.17c0,1.41.58,2,1.35,2,2.16,0,.63-4.78,3.38-4.78,1.17,0,2,1,2,2.84A4.57,4.57,0,0,1,196.84,94.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84,88.07l-.56-.32a4.18,4.18,0,0,0,.87-2.6c0-1.51-.53-2.12-1.35-2.12-2.09,0-.55,4.77-3.38,4.77-1.09,0-2-.91-2-2.73a4.5,4.5,0,0,1,.7-2.47l.56.32a3.65,3.65,0,0,0-.65,2.17c0,1.4.58,2,1.35,2,2.16,0,.63-4.77,3.38-4.77,1.17,0,2,1,2,2.84A4.57,4.57,0,0,1,196.84,88.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.31,
    cy: 57.86,
    r: 2.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.45,
    y: 65.5,
    width: 1.72,
    height: 39.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.48,297.23a102.07,102.07,0,0,1,7.26-7.63,104.87,104.87,0,0,1,7.63-7.26c.1.1-3.15,3.52-7.27,7.63S383.58,297.33,383.48,297.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.37,297.23a104.87,104.87,0,0,1-7.63-7.26,102.07,102.07,0,0,1-7.26-7.63c.1-.1,3.51,3.15,7.63,7.26S398.47,297.13,398.37,297.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.28,216.47a104.64,104.64,0,0,1,7.26-7.63,102.07,102.07,0,0,1,7.63-7.26c.1.1-3.15,3.51-7.26,7.63S247.38,216.57,247.28,216.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.17,216.47c-.1.1-3.52-3.15-7.63-7.26a104.41,104.41,0,0,1-7.26-7.63,104.41,104.41,0,0,1,7.63,7.26C259,213,262.27,216.37,262.17,216.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,86.14a79.77,79.77,0,0,1-1-9,78.73,78.73,0,0,1-.53-9,78.3,78.3,0,0,1,1.05,9A77.26,77.26,0,0,1,226.86,86.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1,76.33a79,79,0,0,1-9,1,81.76,81.76,0,0,1-9,.53,75.72,75.72,0,0,1,9-1.05A77.22,77.22,0,0,1,235.1,76.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,185a1.66,1.66,0,0,1-.19-.28l-.49-.8-1.81-3-6.27-10.62.31.08L120.12,179c0,.08.18-.67.09-.35h0l0,0,0,.06.08.13.14.25.3.51.58,1q.57,1,1.14,2l2.2,3.84,4,7-.31-.09,10.74-6.07,3.07-1.7.82-.44.31-.15a10,10,0,0,1-1,.64l-3,1.77-10.75,6.34-.2.12-.11-.2-4.06-7-2.22-3.83q-.57-1-1.14-2l-.59-1-.29-.51-.14-.25-.08-.13,0-.06,0,0h0c-.08.31.12-.44.1-.36L134.7,170l.19-.11.11.19L141.15,181l1.67,3A11.75,11.75,0,0,1,143.37,185Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.9,281.33s-.13-.34-.45-.87a4.08,4.08,0,0,0-2-1.66,3.87,3.87,0,0,0-3.62.43,3.8,3.8,0,1,0,5.16,5.48,4,4,0,0,0,.9-2.4c0-.63-.07-1,0-1a1.84,1.84,0,0,1,.23,1,4,4,0,0,1-.81,2.62,4.19,4.19,0,0,1-3.7,1.65,4.25,4.25,0,0,1-2-7.75,4.2,4.2,0,0,1,4-.37,4,4,0,0,1,2,1.9A1.83,1.83,0,0,1,470.9,281.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,43.32c-.05,0-.14-.34-.46-.87a4,4,0,0,0-2-1.66,3.88,3.88,0,0,0-3.62.43,3.8,3.8,0,1,0,5.16,5.48,4,4,0,0,0,.9-2.4c0-.63-.07-1,0-1a2.11,2.11,0,0,1,.23,1,4,4,0,0,1-.82,2.62,4.19,4.19,0,0,1-3.7,1.65,4.25,4.25,0,0,1-2-7.75,4.2,4.2,0,0,1,4-.37,4,4,0,0,1,2,1.9A2.1,2.1,0,0,1,284,43.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,157.77s-.14-.34-.46-.87a4,4,0,0,0-2-1.66,3.87,3.87,0,0,0-3.62.43,3.79,3.79,0,0,0,1.79,6.88,3.87,3.87,0,0,0,3.37-1.4,4.09,4.09,0,0,0,.9-2.4c0-.62-.08-1,0-1a2.11,2.11,0,0,1,.23,1,4,4,0,0,1-.81,2.63A4.17,4.17,0,0,1,93.73,163a4.24,4.24,0,0,1-2-7.74,4.22,4.22,0,0,1,4-.38,4.08,4.08,0,0,1,2,1.9A2.13,2.13,0,0,1,98,157.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.72,141.78c-.06,0-.22-.73-.88-1.9a8.48,8.48,0,0,0-8-4.26,8.36,8.36,0,0,0-4.13,1.48,7.7,7.7,0,0,0-1.75,1.63,8.19,8.19,0,0,0-1.25,2.15,8.28,8.28,0,0,0,2.48,9.5,7.91,7.91,0,0,0,2.14,1.27,8.12,8.12,0,0,0,2.32.57,8.39,8.39,0,0,0,4.33-.74,8.21,8.21,0,0,0,3-2.38,8.52,8.52,0,0,0,1.86-5.23c0-1.35-.23-2.08-.16-2.09a3.19,3.19,0,0,1,.16.53,7.6,7.6,0,0,1,.21,1.56,8.64,8.64,0,0,1-4.91,8,8.73,8.73,0,0,1-4.56.82,8.31,8.31,0,0,1-2.46-.58,8,8,0,0,1-2.28-1.34,8.74,8.74,0,0,1-2.63-10.08,8.05,8.05,0,0,1,1.34-2.27,8.17,8.17,0,0,1,1.86-1.72,8.68,8.68,0,0,1,8.35-.82,8.54,8.54,0,0,1,4.22,3.9,6.84,6.84,0,0,1,.58,1.46A3.57,3.57,0,0,1,453.72,141.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.78,268.37a9.36,9.36,0,0,1-.52-.92l-1.49-2.75c-1.27-2.37-3.11-5.78-5.19-9.79l-.2-.39.44,0,7.41.46,7.69.51.42,0-.23.35c-2.42,3.73-4.53,6.89-6,9.08l-1.71,2.54a8.66,8.66,0,0,1-.61.85s.21-.38.6-1,1-1.58,1.65-2.67c1.4-2.27,3.35-5.42,5.67-9.06l.19.38-7.69-.48-7.42-.49.24-.36c2,3.91,3.64,7.29,4.84,9.73.58,1.17,1.05,2.13,1.41,2.87S426.78,268.35,426.78,268.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.05,79.54s-.18-.3-.53-.93L355,75.87c-1.27-2.37-3.11-5.79-5.19-9.8l-.2-.38.43,0,7.42.47,7.69.51.42,0-.23.35c-2.42,3.72-4.54,6.88-6,9.07l-1.71,2.55a8.66,8.66,0,0,1-.61.85s.21-.38.6-1l1.64-2.67c1.41-2.27,3.35-5.41,5.68-9l.19.38-7.69-.48-7.42-.5.24-.35c2,3.9,3.64,7.28,4.84,9.72q.86,1.77,1.41,2.88C356.87,79.13,357.05,79.51,357.05,79.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1,302.58a7.93,7.93,0,0,1,.56-.9l1.72-2.6c1.47-2.24,3.6-5.48,6.16-9.23l.2-.3.2.3,4.77,7,3.71,5.54.27.39h-.47c-5,0-9.37-.09-12.39-.14l-3.52-.07c-.81,0-1.24,0-1.21,0s.5,0,1.35-.05l3.6-.06c3.06-.05,7.28-.13,12.17-.14l-.21.39-3.73-5.53c-1.68-2.49-3.28-4.88-4.74-7.07h.4c-2.51,3.62-4.69,6.68-6.27,8.89l-1.86,2.6C236.37,302.23,236.12,302.57,236.1,302.58Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.72,297.41h0A62.61,62.61,0,0,1,392.33,360v72.6a0,0,0,0,1,0,0H267.11a0,0,0,0,1,0,0V360A62.61,62.61,0,0,1,329.72,297.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,397.4l-6.3,4.46-7,16.81s1.9,1.28,3.37-.08,7.09-11.13,7.09-11.13l0,5.78a4.64,4.64,0,0,0,4.11,4.58l10.38,3.24,12.74-3.63,1.09-15.16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,285.63c-3.12-.9-4.65-4.47-4.93-7.7s.25-6.57-.63-9.69c-.63-2.22-1.95-4.26-2.12-6.56-.18-2.48,1-4.87,1.08-7.35.09-3.47-2-6.69-2-10.16-.07-4.8.79-12.73,5.59-12.46s12.49,8.68,11.88,13.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,245.89l-.1,4.8-1,71.76c-.11,8.33-7.36,14.87-16.28,14.68h0c-9-.19-16.33-7.16-16.35-15.58,0-8.84-.22-18.14-.22-18.14s-11.38-1.89-13.74-16.74c-1.17-7.38-.8-19.49-.18-29.39a15.69,15.69,0,0,1,17.3-14.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.93,265.71a1.92,1.92,0,0,0,1.84,1.93,1.82,1.82,0,0,0,2-1.72A1.89,1.89,0,0,0,286.9,264,1.82,1.82,0,0,0,284.93,265.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,263.58c.23.25,1.68-.82,3.73-.81s3.55,1,3.77.78-.13-.56-.79-1a5.28,5.28,0,0,0-3-.93,5,5,0,0,0-3,1C284.62,263,284.4,263.47,284.52,263.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,265.71a1.9,1.9,0,0,0,1.83,1.93,1.84,1.84,0,0,0,2-1.72,1.9,1.9,0,0,0-1.84-1.92A1.81,1.81,0,0,0,305.45,265.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.66,264c.24.25,1.68-.81,3.73-.81s3.55,1,3.78.78-.13-.56-.79-1a5.33,5.33,0,0,0-3-.93,5.05,5.05,0,0,0-3,1C304.76,263.4,304.55,263.85,304.66,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,279.16a14.45,14.45,0,0,0-3.33-.6c-.53-.05-1-.16-1.11-.51a2.7,2.7,0,0,1,.35-1.55l1.55-4c2.15-5.67,3.7-10.34,3.47-10.42s-2.15,4.44-4.3,10.12c-.52,1.4-1,2.73-1.49,4a3.1,3.1,0,0,0-.27,2,1.32,1.32,0,0,0,.86.76,3.47,3.47,0,0,0,.89.13A13.13,13.13,0,0,0,297.23,279.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.81,303.41a37.75,37.75,0,0,0,19.89-5.3s-4.83,10.2-19.69,8.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,284.1a3.7,3.7,0,0,1,3.31-1.37,3.37,3.37,0,0,1,2.33,1.25,2.13,2.13,0,0,1,.16,2.44,2.46,2.46,0,0,1-2.68.68,7.8,7.8,0,0,1-2.62-1.56,2.28,2.28,0,0,1-.59-.61.68.68,0,0,1,0-.76",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.26,280.58c-.34,0-.34,2.21-2.24,3.78s-4.28,1.34-4.29,1.65c0,.14.52.43,1.52.46a5.56,5.56,0,0,0,3.59-1.25,4.8,4.8,0,0,0,1.73-3.17C303.66,281.12,303.41,280.57,303.26,280.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.13,255.93c.21.56,2.25.3,4.66.59s4.35.94,4.66.44c.15-.24-.19-.76-1-1.3a8.14,8.14,0,0,0-7.1-.78C304.49,255.23,304.05,255.67,304.13,255.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.27,257.65c.36.47,1.77,0,3.47,0s3.14.31,3.47-.17c.14-.24-.08-.71-.71-1.15a4.85,4.85,0,0,0-2.82-.76,4.79,4.79,0,0,0-2.77.94C285.31,256.94,285.11,257.42,285.27,257.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.19,241.33c3.09-8.39,15.95-21,25.84-15.4,10.83,6.16,7,10.44,10.91,13.28.93.67,5.33-.79,5.94.19,1.61,2.59.24,5.94-1.13,8.66a4.67,4.67,0,0,0,1-.26,1.81,1.81,0,0,1,2.47,1.75,16.89,16.89,0,0,1-3.35,9.19,5.35,5.35,0,0,0,2.07.07,1.28,1.28,0,0,1,1.41,1.69,10.18,10.18,0,0,1-7.45,6.34c-4.13.85-8.49-.65-11.86-3.18s-5.91-6-8.19-9.57c-1.33-2.05-2.64-4.21-4.62-5.65s-4.83-2-6.86-.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,247.48s0-.16,0-.39a3.32,3.32,0,0,0-.25-1,16.05,16.05,0,0,0-1.61-3,18.83,18.83,0,0,0-2.11-2.74c-.6-.64-1.05-1-1-1a2.9,2.9,0,0,1,1.26.77,13.64,13.64,0,0,1,2.29,2.72,11.57,11.57,0,0,1,1.52,3.22,2.72,2.72,0,0,1,.11,1.11C341.49,247.37,341.37,247.5,341.35,247.48Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.46,270.5s-.11.11-.36.27a6.19,6.19,0,0,1-1.14.61,9.41,9.41,0,0,1-4.68.62,9.83,9.83,0,0,1-6.2-3.18,10.07,10.07,0,0,1-2-3.7,19.73,19.73,0,0,1-.73-4.41c-.19-3-.07-5.93-.61-8.47a12,12,0,0,0-1.23-3.43,7.84,7.84,0,0,0-2.08-2.35,6.44,6.44,0,0,0-4.26-1.44,10,10,0,0,0-1.66.35,1.51,1.51,0,0,1,.39-.22,4.78,4.78,0,0,1,1.25-.34,6.55,6.55,0,0,1,4.5,1.35,8.13,8.13,0,0,1,2.23,2.44,12.15,12.15,0,0,1,1.33,3.54c.58,2.61.47,5.54.66,8.54a19.81,19.81,0,0,0,.7,4.3,9.76,9.76,0,0,0,1.85,3.53,9.79,9.79,0,0,0,10.45,2.68C365.92,270.81,366.43,270.45,366.46,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,230.13a2.46,2.46,0,0,1,.29.56,5.68,5.68,0,0,1,.38,1.78,6.44,6.44,0,0,1-.47,2.84,6,6,0,0,1-2.45,2.93,6.44,6.44,0,0,1-4.55.73,6.2,6.2,0,0,1-4.27-3.09,17.52,17.52,0,0,1-1.72-5.59c-.4-1.95-.78-4.06-2.1-5.65a4.87,4.87,0,0,0-2.5-1.58,6.54,6.54,0,0,0-2.92-.05,15.65,15.65,0,0,0-5.22,2.23,47.21,47.21,0,0,0-7.76,5.93,51.13,51.13,0,0,0-4.49,4.83l-1.12,1.41a2.23,2.23,0,0,1-.41.48,3.14,3.14,0,0,1,.33-.54c.22-.35.58-.84,1-1.47a42.6,42.6,0,0,1,4.4-5,45.08,45.08,0,0,1,7.75-6.07,16.13,16.13,0,0,1,5.38-2.32,6.9,6.9,0,0,1,3.16.05A5.45,5.45,0,0,1,362,224.3c1.44,1.75,1.81,3.95,2.2,5.89a17.27,17.27,0,0,0,1.63,5.45,5.78,5.78,0,0,0,3.94,2.91,6.14,6.14,0,0,0,4.28-.63,5.77,5.77,0,0,0,2.37-2.72,6.52,6.52,0,0,0,.54-2.72A7.76,7.76,0,0,0,376.44,230.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,226.6a4.1,4.1,0,0,1,1.09,1.65,8.31,8.31,0,0,1-1.56,9.07,4.16,4.16,0,0,1-1.58,1.2c-.05-.07.56-.52,1.31-1.44a8.88,8.88,0,0,0,1.49-8.69C339.23,227.27,338.8,226.64,338.88,226.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,245.06a18.77,18.77,0,0,0-13.49-11.43A17.46,17.46,0,0,0,316,235.1a17.21,17.21,0,0,1-3.37-2.85,29.49,29.49,0,0,0-12.7-7.55,21.05,21.05,0,0,0-14.58,1.13,16.44,16.44,0,0,0-9,11.25,13.54,13.54,0,0,0,4.84,13.3c4,3,10,3.07,13.85-.1-.27,2.19,1.65,4.22,3.82,4.63a8.11,8.11,0,0,0,6.17-1.8,46.63,46.63,0,0,0,4.76-4.57c.59-.57,1.2-1.12,1.82-1.65a17.92,17.92,0,0,0,12.5,10c-1.72,1.87-1.57,4.8-.86,7.24s1.86,4.82,1.81,7.36c0,2.14-.95,4.15-1.36,6.25a13.65,13.65,0,0,0,1.21,8.66c.51,1,1.14,2.46,1.71,3.45,1,1.78,1,1.78,2.48,2.23,3.06.95,8.34-10.16,9.7-14.57,1.14-3.68,1.58-10.28,2.91-13.89C344.05,257.14,342.6,250.78,340.36,245.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42,259a1.42,1.42,0,0,1-.21.33,3.06,3.06,0,0,1-.84.73,4.24,4.24,0,0,1-4,.15,3.62,3.62,0,0,1-1.12-.86,5.35,5.35,0,0,1-.78-1.28,15.73,15.73,0,0,0-1.36-2.84,4.24,4.24,0,0,0-2.88-1.54,28.56,28.56,0,0,0-3.76-.16,16.45,16.45,0,0,1-3.82-.53,17.48,17.48,0,0,1-3.34-1.32,16.56,16.56,0,0,1-4.75-3.73,14.25,14.25,0,0,1-2.26-3.39,8.69,8.69,0,0,1-.43-1,1.27,1.27,0,0,1-.11-.38,21.51,21.51,0,0,0,3.07,4.53,17,17,0,0,0,4.7,3.56,18.43,18.43,0,0,0,3.25,1.25,16.43,16.43,0,0,0,3.7.5,27,27,0,0,1,3.83.18,4.71,4.71,0,0,1,3.18,1.75,15.07,15.07,0,0,1,1.37,3,5.19,5.19,0,0,0,.7,1.2,3.48,3.48,0,0,0,1,.8,4.14,4.14,0,0,0,3.76,0A5.88,5.88,0,0,0,342.42,259Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,265s-.18.27-.63.61a6.57,6.57,0,0,1-2.12,1.06,6.88,6.88,0,0,1-3.53.12,7.28,7.28,0,0,1-3.75-2.17,17.86,17.86,0,0,1-2.26-3.65,9.21,9.21,0,0,0-2-2.73,4.75,4.75,0,0,0-1.94-1.11,7.16,7.16,0,0,1-.84-.17,1.85,1.85,0,0,1,.88,0,4.4,4.4,0,0,1,2.14,1,9.31,9.31,0,0,1,2.17,2.78,18.18,18.18,0,0,0,2.22,3.53,7,7,0,0,0,3.47,2.06,6.86,6.86,0,0,0,3.32,0A11,11,0,0,0,340.11,265Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,247.58a1.45,1.45,0,0,1-.14.56,4.22,4.22,0,0,1-.9,1.43,5.5,5.5,0,0,1-2.26,1.43,6,6,0,0,1-3.53.14c-2.63-.64-5.1-3-6.61-6.12s-2.46-6.83-4.77-10a10.07,10.07,0,0,0-4.38-3.42,11.8,11.8,0,0,0-5.16-.75,13.43,13.43,0,0,0-8,3.56,19.13,19.13,0,0,0-3.8,4.73c-.72,1.25-1,2-1.07,2a1.84,1.84,0,0,1,.19-.56,15.73,15.73,0,0,1,.71-1.51,18.12,18.12,0,0,1,3.72-4.9,13.69,13.69,0,0,1,8.25-3.77,12.1,12.1,0,0,1,5.39.76,10.34,10.34,0,0,1,4.6,3.58c2.4,3.29,3.24,7.08,4.79,10.08s3.8,5.33,6.27,6a5.74,5.74,0,0,0,3.35-.06,5.06,5.06,0,0,0,3.39-3.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.14,254.6s-.11.16-.36.43a11.51,11.51,0,0,1-1.23,1.06,9.76,9.76,0,0,1-2.24,1.25,7.29,7.29,0,0,1-3.37.51,11.16,11.16,0,0,1-7.37-4.62,16.82,16.82,0,0,1-2.34-4.68c-.6-1.7-1.07-3.5-1.71-5.28a15.4,15.4,0,0,0-2.59-4.78,8.18,8.18,0,0,0-4.15-2.69,11.74,11.74,0,0,0-8.34,1.06,22.85,22.85,0,0,0-4.77,3.38l-1.19,1.08a2.45,2.45,0,0,1-.43.37,2,2,0,0,1,.36-.44c.24-.28.61-.67,1.12-1.16a20.81,20.81,0,0,1,4.74-3.55,12,12,0,0,1,8.64-1.2,8.64,8.64,0,0,1,4.41,2.82,15.92,15.92,0,0,1,2.69,4.93c.65,1.81,1.12,3.61,1.7,5.3a16.94,16.94,0,0,0,2.24,4.55,10.91,10.91,0,0,0,7,4.54,7.08,7.08,0,0,0,3.23-.41,10.11,10.11,0,0,0,2.22-1.15C378.58,255.14,379.11,254.57,379.14,254.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.21,403.43l1.69,4.22-3.33,38.49h84.95l-3.79-11.51,10.56.54c16.29.82,29.6-13.73,26.43-29.73-.1-.48-.2-1-.33-1.44-5.27-20.59-12.44-48.27-14.93-56.44-4.13-13.51-13.32-19.93-13.32-19.93H359c-12.71-10.37-30-11.29-30-11.29l-6.37,4.28a22.2,22.2,0,0,1-21.53,1.77,9.64,9.64,0,0,1-5.25-6.05h0A74.79,74.79,0,0,0,274.14,322a31.8,31.8,0,0,0-16.79,18.75l-22.19,65-37.78-5.11-8.08,22.06,38.28,9.12a31.25,31.25,0,0,0,36.37-15l7.26-13.35m70.66,5.2h0s3.63-13.92,5.84-21.41l5.36,21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,435.39l-.44,0-1.28,0-5,0-18.71.07-65.11.09H280v-.25c.33-7.94.69-16.27,1.05-24.87v-.24h.24l24.19-.76L353.07,408l-.23.31c-1.78-6.49-3.23-12.81-4.63-18.84s-2.65-11.81-3.88-17.25q-.88-4.08-1.73-7.92a57.2,57.2,0,0,1-1.36-7.47,38.31,38.31,0,0,1,0-7,32.6,32.6,0,0,1,1.16-6.33,19.51,19.51,0,0,1,5.66-9.24,14.25,14.25,0,0,1,7.31-3.4,11.84,11.84,0,0,1,5.05.28,9.52,9.52,0,0,1,1.23.45c.27.11.4.18.4.18s-.55-.25-1.65-.55a12,12,0,0,0-5-.21,14.18,14.18,0,0,0-7.18,3.43,19.31,19.31,0,0,0-5.53,9.14,32.87,32.87,0,0,0-1.12,6.28,37.72,37.72,0,0,0,0,7,56.19,56.19,0,0,0,1.38,7.42c.57,2.55,1.15,5.19,1.76,7.91,1.23,5.44,2.54,11.2,3.91,17.23s2.87,12.35,4.66,18.82l.08.3h-.31L305.51,410l-24.2.76.25-.25c-.37,8.6-.73,16.93-1.07,24.87l-.25-.26,65.11.1,18.71.07,5,0,1.28,0A3.72,3.72,0,0,1,370.76,435.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.92,346.85a2.37,2.37,0,0,1,.05.62c0,.41,0,1,0,1.79a29.29,29.29,0,0,1-1.15,6.47,92.35,92.35,0,0,1-3.32,9.15,62.74,62.74,0,0,0-3.66,11.26,33.93,33.93,0,0,0-.06,11.76,66.4,66.4,0,0,0,2.3,9.4c.84,2.63,1.59,4.74,2.11,6.2l.58,1.68a2.43,2.43,0,0,1,.17.6,2.54,2.54,0,0,1-.27-.56c-.17-.43-.4-1-.67-1.65-.58-1.44-1.38-3.53-2.27-6.16a61.89,61.89,0,0,1-2.42-9.44,33.66,33.66,0,0,1,0-11.93A61.56,61.56,0,0,1,271,364.7c1.4-3.38,2.63-6.43,3.41-9.07a32.09,32.09,0,0,0,1.31-6.38C275.88,347.71,275.87,346.85,275.92,346.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.07,408.27a4.18,4.18,0,0,1,1.78-.23,10.49,10.49,0,0,1,4.21,1,7.82,7.82,0,0,1,3.35,2.75,3.16,3.16,0,0,1,.65,1.67c-.09,0-.3-.62-.95-1.46a8.61,8.61,0,0,0-3.27-2.49,12.66,12.66,0,0,0-4-1.07A13,13,0,0,1,353.07,408.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,320.1a10.4,10.4,0,0,1,1.59.6c.51.21,1.13.46,1.84.78l2.37,1.16c.88.43,1.81,1,2.82,1.53s2,1.24,3.12,1.94a49.2,49.2,0,0,1,6.55,5.32,33.53,33.53,0,0,1,8.26,12.8,21.76,21.76,0,0,1,.76,2.54c.18.76.35,1.4.42,2a12.42,12.42,0,0,1,.22,1.69,9.72,9.72,0,0,1-.42-1.65c-.09-.54-.29-1.17-.5-1.92s-.49-1.57-.82-2.49a35,35,0,0,0-8.28-12.55,50.78,50.78,0,0,0-6.46-5.29c-1.07-.7-2.09-1.39-3.07-2s-1.9-1.13-2.77-1.58l-2.33-1.22-1.79-.86A11.74,11.74,0,0,1,345.59,320.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.28,362s-8.44,37.27-8.31,40.92a20.46,20.46,0,0,0,.87,5.66l7,.06.06-.69,5.9-21.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M295.9,360.12c0,.06-.89.41-2.31,1.46a13,13,0,0,0-4.33,5.89,12.46,12.46,0,0,0-.69,5,12.18,12.18,0,0,0,1.68,5.53,12.44,12.44,0,0,0,4.5,4.5,11.69,11.69,0,0,0,3.13,1.3,12.17,12.17,0,0,0,3.47.4,12.83,12.83,0,0,0,3.45-.56,13.72,13.72,0,0,0,3.07-1.45,12.6,12.6,0,0,0,4.74-15.31,12.92,12.92,0,0,0-4.62-5.67c-1.46-1-2.41-1.29-2.38-1.35a5,5,0,0,1,.68.24,11.87,11.87,0,0,1,1.82.94A12.83,12.83,0,0,1,314,371.88a13.16,13.16,0,0,1-1.42,5.82,13,13,0,0,1-4.42,4.93,14.43,14.43,0,0,1-3.19,1.53,13.55,13.55,0,0,1-3.6.58,12.87,12.87,0,0,1-6.87-1.78,12.87,12.87,0,0,1-4.66-4.7,12.81,12.81,0,0,1,3.64-16.84,11.8,11.8,0,0,1,1.77-1A5.72,5.72,0,0,1,295.9,360.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,357.84a82.29,82.29,0,0,1,.26,9.18,82.29,82.29,0,0,1-.26,9.18,79.49,79.49,0,0,1-.26-9.18A79.49,79.49,0,0,1,301.05,357.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.81,410l-5.5-2.23s-6.39-10.84-7.7-10.32-1.5,3.83,1.1,8.82l-7.23-1.63s-15,8-14.29,8.91,2.12,3.12,5.39,1.22,7.55-4.17,7.55-4.17l8.45,1.91-10.65,2-9.57,9.73s3.45,2.3,6.16-.49l26.5,4.17h11.22l.6-14.83Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,423.68c.12.06.56-.74,1.45-1.82a7.86,7.86,0,0,1,1.82-1.58,8,8,0,0,1,2.79-.89c4.33-.76,7.82-1.56,7.78-1.78s-3.58.21-7.93,1a7.61,7.61,0,0,0-3.05,1.07,7.17,7.17,0,0,0-1.87,1.86A4.66,4.66,0,0,0,242.52,423.68Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.68,424.5c.1,0,.15-.55.87-.75s1.93-.38,3.16-.58c2.5-.4,4.57-.49,4.58-.73s-2.11-.49-4.7-.08a13.4,13.4,0,0,0-3.26.86,1.31,1.31,0,0,0-.75.86C246.53,424.37,246.63,424.51,246.68,424.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08,409.68a18.9,18.9,0,0,1-2.65-.75c-1.62-.5-3.87-1.13-6.38-1.76l-6.43-1.62a13.79,13.79,0,0,1-2.63-.81,15.51,15.51,0,0,1,2.72.46c1.66.34,4,.83,6.47,1.47a64.63,64.63,0,0,1,6.37,1.91A11.88,11.88,0,0,1,268.08,409.68Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.31,130.74a8.06,8.06,0,0,1-.06-1.08q0-1.12-.06-3c0-2.58-.06-6.15-.11-10.41l.22.23-14.46,0c0,.06.5-.49.26-.26h0v3.87c0,1.28,0,2.53,0,3.74,0,2.43,0,4.72,0,6.82l-.23-.22,10.42.11,3,.06c.69,0,1.07,0,1.09.05a6.11,6.11,0,0,1-1,.06l-2.91,0-10.56.12h-.22v-.23c0-2.1,0-4.39,0-6.82,0-1.21,0-2.46,0-3.74v-3.87h0c-.23.24.32-.32.26-.26l14.46,0h.23v.22c0,4.32-.09,7.94-.11,10.56q0,1.8-.06,2.91A9.61,9.61,0,0,1,360.31,130.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.31,116.43c.1.1-3.05,3.4-7,7.37a100.12,100.12,0,0,1-7.4,7,99.43,99.43,0,0,1,7-7.37A95.65,95.65,0,0,1,360.31,116.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.08,130.65a92,92,0,0,1-7.24-6.92,96.44,96.44,0,0,1-6.87-7.3,97.87,97.87,0,0,1,7.24,6.93A100.16,100.16,0,0,1,360.08,130.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.93,214.89a4.52,4.52,0,0,1,.77-.88c.61-.6,1.36-1.36,2.24-2.24,1.91-1.88,4.58-4.45,7.54-7.27l.07-.06v.38c-3-2.77-5.67-5.29-7.59-7.13l-2.25-2.2a4.39,4.39,0,0,1-.78-.86,5.55,5.55,0,0,1,.91.71l2.37,2.08c2,1.77,4.71,4.25,7.7,7l.2.19-.2.19-.07.07c-3,2.81-5.67,5.34-7.64,7.15l-2.36,2.13A5.18,5.18,0,0,1,445.93,214.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.87,194.63a4.52,4.52,0,0,1-.77.88l-2.25,2.24c-1.91,1.88-4.57,4.45-7.53,7.27l-.07.06v-.38c3,2.77,5.66,5.29,7.59,7.13l2.25,2.2a4.39,4.39,0,0,1,.78.86,4.91,4.91,0,0,1-.91-.71c-.65-.56-1.44-1.26-2.37-2.08-2-1.77-4.71-4.25-7.7-7l-.2-.19.2-.19.07-.07c3-2.81,5.67-5.34,7.64-7.15l2.36-2.13A5.87,5.87,0,0,1,422.87,194.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.79,219.66c-.13,0,2.29-6.83,5.4-15.13s5.76-15,5.9-14.95-2.29,6.83-5.41,15.13S428.92,219.71,428.79,219.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.12,234.16s0-.4,0-1.14,0-1.84,0-3.26c0-2.86,0-7-.06-12.34,0-10.63-.07-25.81-.11-44.12l.21.21-75,.05h0l.26-.26c0,22,0,42.77,0,60.86l-.24-.24,54.15.12,15.35.06,4.08,0h1.05l.36,0h-1.36l-4,0-15.3.06-54.3.12h-.23v-.23c0-18.09,0-38.86,0-60.86V173h.27l75,0h.22v.22c0,18.36-.08,33.6-.11,44.26,0,5.29,0,9.44-.06,12.29,0,1.4,0,2.48,0,3.22S472.12,234.16,472.12,234.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.71,182.33c0,.14-16.93.26-37.8.26s-37.81-.12-37.81-.26,16.92-.26,37.81-.26S472.71,182.18,472.71,182.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25,177.88a1,1,0,1,1-1-1A1,1,0,0,1,403.25,177.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.93,177.88a1,1,0,1,1-1-1A1,1,0,0,1,406.93,177.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,177.88a1,1,0,1,1-1-1A1,1,0,0,1,410.61,177.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.34,
    y: 81.31,
    width: 59.25,
    height: 42.24,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.06,87.58c0,.14-13.38.26-29.87.26s-29.87-.12-29.87-.26,13.37-.26,29.87-.26S320.06,87.43,320.06,87.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.18,84.49a.81.81,0,1,1-.8-.7A.76.76,0,0,1,265.18,84.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.09,84.49a.81.81,0,1,1-.8-.7A.76.76,0,0,1,268.09,84.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.2,
    cy: 84.49,
    rx: 0.8,
    ry: 0.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,104.42c0,2.54-1.84,4.07-4.87,4.07h-3.2v3.76h-1.26V100.34h4.46C280.42,100.34,282.26,101.87,282.26,104.42Zm-1.26,0c0-1.9-1.26-3-3.64-3h-3.17v5.95h3.17C279.74,107.38,281,106.29,281,104.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.93,100.34v11.91h-1.24v-5.5h-7.46v5.5H285V100.34h1.26v5.31h7.46v-5.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.12,104.42c0,2.54-1.83,4.07-4.86,4.07h-3.2v3.76H298.8V100.34h4.46C306.29,100.34,308.12,101.87,308.12,104.42Zm-1.25,0c0-1.9-1.26-3-3.64-3h-3.17v5.95h3.17C305.61,107.38,306.87,106.29,306.87,104.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,172l.78-.86a4.63,4.63,0,0,0,3.92,2.23c2.35,0,3.51-1.34,3.51-4.17V157.86h-6.52V156.7h7.81v12.47c0,3.56-1.65,5.33-4.8,5.33A5.53,5.53,0,0,1,200,172Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,172.78l.58-1a7.65,7.65,0,0,0,4.74,1.59c2.78,0,3.89-1,3.89-2.47,0-3.84-8.73-1-8.73-6.19,0-2,1.66-3.61,5-3.61a8.07,8.07,0,0,1,4.52,1.29l-.58,1a6.78,6.78,0,0,0-4-1.19c-2.57,0-3.71,1.06-3.71,2.48,0,4,8.74,1.16,8.74,6.18,0,2.15-1.85,3.61-5.21,3.61A8.24,8.24,0,0,1,213.2,172.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,183.76s0-.28,0-.81,0-1.31,0-2.29c0-2,0-4.95-.06-8.66,0-7.45-.06-18.05-.11-30.8l.22.22-45.87,0c-.06.06.49-.49.26-.25h0v11.42c0,3.75,0,7.41,0,11,0,7.15,0,13.91,0,20.14l-.23-.23,33.15.11,9.37.06,2.48,0H235l.23,0h-.82l-2.44,0-9.31.06-33.3.11h-.23v-.23c0-6.23,0-13,0-20.14,0-3.57,0-7.23,0-11V141.22h0l.26-.27,45.87,0h.22v.22c0,12.81-.08,23.46-.11,30.94,0,3.69,0,6.6-.06,8.61,0,1,0,1.72,0,2.25S235.2,183.76,235.2,183.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1,147.52c0,.14-10.25.26-22.9.26s-22.9-.12-22.9-.26,10.25-.27,22.9-.27S235.1,147.37,235.1,147.52Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.4,
    cy: 144.41,
    rx: 0.8,
    ry: 0.71,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13,144.41a.81.81,0,1,1-.8-.71A.76.76,0,0,1,197.13,144.41Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.06,144.41a.81.81,0,1,1-.8-.71A.76.76,0,0,1,200.06,144.41Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,101.58a7.39,7.39,0,0,1,7.67-7.51,7.05,7.05,0,0,1,5.26,2.05l-.67.7a6.18,6.18,0,0,0-4.54-1.75,6.51,6.51,0,1,0,0,13,6.19,6.19,0,0,0,4.54-1.77l.67.7a7.07,7.07,0,0,1-5.26,2.07A7.39,7.39,0,0,1,402.47,101.58Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.43,107.07l.49-.8a7.06,7.06,0,0,0,4.88,1.86c3,0,4.27-1.29,4.27-2.9,0-4.44-9.23-1.77-9.23-7.23,0-2.09,1.6-3.93,5.24-3.93a8,8,0,0,1,4.46,1.33l-.41.87A7.32,7.32,0,0,0,423.08,95c-2.88,0-4.17,1.33-4.17,3,0,4.44,9.24,1.82,9.24,7.19,0,2.09-1.67,3.91-5.33,3.91A7.6,7.6,0,0,1,417.43,107.07Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,107.07l.49-.8a7,7,0,0,0,4.88,1.86c3,0,4.27-1.29,4.27-2.9,0-4.44-9.24-1.77-9.24-7.23,0-2.09,1.61-3.93,5.25-3.93a8,8,0,0,1,4.45,1.33l-.4.87A7.32,7.32,0,0,0,436,95c-2.88,0-4.17,1.33-4.17,3,0,4.44,9.24,1.82,9.24,7.19,0,2.09-1.67,3.91-5.33,3.91A7.6,7.6,0,0,1,430.3,107.07Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,120.81s0-.28,0-.79,0-1.28,0-2.25c0-2,0-4.87-.06-8.56,0-7.39-.06-18-.11-31l.21.21-65.89.05h0l.26-.26c0,15.11,0,29.5,0,42.56l-.24-.24,47.4.12,13.59.06,3.63,0h.94a2.06,2.06,0,0,1,.33,0h-.3l-.91,0-3.58,0-13.54.06-47.56.12h-.24v-.24c0-13.06,0-27.45,0-42.56V78h.26l65.89.06h.21v.2c-.05,13-.09,23.67-.11,31.09,0,3.67,0,6.54,0,8.51q0,1.44,0,2.22C453.63,120.56,453.61,120.81,453.61,120.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.61,84.57c0,.14-14.76.26-33,.26s-33-.12-33-.26,14.76-.26,33-.26S453.61,84.42,453.61,84.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,81.46a.81.81,0,1,1-.8-.71A.76.76,0,0,1,392.59,81.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,81.46a.81.81,0,1,1-.8-.71A.76.76,0,0,1,395.52,81.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.45,81.46a.81.81,0,1,1-.8-.71A.76.76,0,0,1,398.45,81.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.9,
    y: 142.86,
    width: 82.74,
    height: 58.98,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,170.24V182H311.1v-4.8h-5.32V182h-2.71V170.24h2.71v4.62h5.32v-4.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,172.45h-3.75v-2.21h10.21v2.21h-3.75V182H319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.92,170.24h2.71v9.5h5.87V182h-8.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.68,182l0-7-3.45,5.78H343l-3.43-5.63V182H337V170.24h2.24l4.39,7.28,4.31-7.28h2.22l0,11.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,151.61c0,.14-18.68.26-41.72.26s-41.71-.12-41.71-.26,18.67-.26,41.71-.26S369.3,151.46,369.3,151.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.66,147.3a1.12,1.12,0,1,1-1.12-1A1.06,1.06,0,0,1,292.66,147.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.72,147.3a1.12,1.12,0,1,1-1.12-1A1.06,1.06,0,0,1,296.72,147.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,147.3a1.12,1.12,0,1,1-1.12-1A1.06,1.06,0,0,1,300.78,147.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.37,259a.8.8,0,0,1,0-.2v-.55c0-.51,0-1.22,0-2.14,0-1.89,0-4.61-.06-8.06,0-6.93-.07-16.79-.12-28.6l.23.22-39.55,0c-.06.05.49-.49.26-.25h0v5.36c0,1.78,0,3.55,0,5.29v10.22c0,6.64,0,12.91,0,18.66l-.22-.23,28.6.12,8.06.06,2.14,0,.55,0h0l-.53,0-2.1,0-8,.06-28.74.12h-.23V259c0-5.75,0-12,0-18.66V219.46h0c-.24.23.31-.33.26-.27l39.55,0h.22v.23c0,11.87-.08,21.78-.11,28.74,0,3.43,0,6.14-.06,8q0,1.35,0,2.1c0,.22,0,.39,0,.53A1,1,0,0,1,115.37,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.37,219.84c.1.1-8.65,9-19.54,19.85S76,259.28,75.92,259.18s8.64-9,19.54-19.86S115.27,219.74,115.37,219.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,258.75c-.1.1-8.82-8.53-19.47-19.27s-19.21-19.54-19.11-19.64,8.82,8.53,19.48,19.27S114.84,258.64,114.74,258.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,230.05c0,.14-15.72.26-35.1.26s-35.09-.12-35.09-.26,15.71-.26,35.09-.26S197.82,229.91,197.82,230.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,236.36c0,.14-15.72.26-35.1.26s-35.09-.12-35.09-.26,15.71-.26,35.09-.26S197.82,236.21,197.82,236.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,242.66c0,.15-15.72.26-35.1.26s-35.09-.11-35.09-.26,15.71-.26,35.09-.26S197.82,242.52,197.82,242.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,249c0,.14-15.72.26-35.1.26s-35.09-.12-35.09-.26,15.71-.26,35.09-.26S197.82,248.82,197.82,249Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.38,223.74c0,.15-7.23.27-16.13.27s-16.13-.12-16.13-.27,7.22-.26,16.13-.26S159.38,223.6,159.38,223.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.36,207.51H75.13l32.93,0,114.3.2h.25V208c0,19.5,0,40.64,0,62.58v.26H208.07l.26-.26v13.59l-.44-.44-13-13,.18.07L63.36,270.7h-.18v-.17c0-19.64.08-35.41.1-46.28,0-5.41,0-9.6,0-12.45,0-1.4,0-2.48,0-3.21s0-1.08,0-1.08,0,.38,0,1.12,0,1.82,0,3.24c0,2.86,0,7.06,0,12.48,0,10.85.06,26.58.1,46.18l-.18-.18,131.74-.08h.11l.07.07,13,13-.45.19V270.27h14.55l-.26.26c0-21.94,0-43.08,0-62.58l.25.25-114.13-.44-33-.16-8.81,0-2.28,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.77,
    y: 410.84,
    width: 86.8,
    height: 21.78,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.22,
    y: 417.95,
    width: 52.9,
    height: 7.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.55,422.17a4.23,4.23,0,1,1-4.23-4.22A4.22,4.22,0,0,1,396.55,422.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.92,
    y: 398.97,
    width: 69.33,
    height: 11.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.92,
    y: 377.2,
    width: 86.8,
    height: 21.78,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.35,387.54a5.62,5.62,0,0,1,9.73-3.47l-1.51,1.4a3.32,3.32,0,0,0-2.57-1.19,3.27,3.27,0,0,0,0,6.53,3.27,3.27,0,0,0,2.57-1.21l1.51,1.4a5.6,5.6,0,0,1-9.73-3.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.43,388.43h-2.54v2.48H435v-2.48h-2.52v-1.78H435v-2.47h1.88v2.47h2.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.25,388.43h-2.54v2.48h-1.88v-2.48h-2.52v-1.78h2.52v-2.47h1.88v2.47h2.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.82,398.37c-.14,0-.26-4.74-.26-10.59s.12-10.6.26-10.6.26,4.75.26,10.6S404,398.37,403.82,398.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,398.37c-.14,0-.26-4.74-.26-10.59s.12-10.6.26-10.6a106,106,0,0,1,.26,10.6A105.69,105.69,0,0,1,400,398.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.9,398.37a105.69,105.69,0,0,1-.26-10.59,106,106,0,0,1,.26-10.6c.14,0,.26,4.75.26,10.6S464,398.37,463.9,398.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.12,398.37c-.14,0-.26-4.74-.26-10.59s.12-10.6.26-10.6.26,4.75.26,10.6S460.26,398.37,460.12,398.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,404.72a2.27,2.27,0,0,1,2.38-2.34,2,2,0,0,1,1.81.91l-.46.32a1.57,1.57,0,0,0-1.35-.69,1.8,1.8,0,0,0,0,3.6,1.58,1.58,0,0,0,1.35-.67l.46.31a2,2,0,0,1-1.81.92A2.28,2.28,0,0,1,419.6,404.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.37,406.51l.29-.5a2.72,2.72,0,0,0,1.64.52c.88,0,1.24-.3,1.24-.75,0-1.21-3-.26-3-2.09,0-.75.65-1.31,1.83-1.31a3,3,0,0,1,1.63.43l-.27.5a2.38,2.38,0,0,0-1.36-.4c-.84,0-1.2.33-1.2.77,0,1.25,3,.3,3,2.08,0,.8-.7,1.32-1.9,1.32A3.15,3.15,0,0,1,424.37,406.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.67,406.51l.29-.5a2.69,2.69,0,0,0,1.64.52c.88,0,1.24-.3,1.24-.75,0-1.21-3-.26-3-2.09,0-.75.65-1.31,1.83-1.31a3,3,0,0,1,1.63.43l-.27.5a2.38,2.38,0,0,0-1.36-.4c-.84,0-1.2.33-1.2.77,0,1.25,3,.3,3,2.08,0,.8-.7,1.32-1.9,1.32A3.15,3.15,0,0,1,428.67,406.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.12,
    cy: 404.86,
    r: 2.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.75,
    cy: 404.86,
    r: 2.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.65,
    y: 294,
    width: 169.82,
    height: 115.71,
    rx: 12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.18 382.21 78.78 435.44 122.9 435.44 130.89 381.12 88.18 382.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.91,
    y: 294,
    width: 169.82,
    height: 115.71,
    rx: 12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.69 409.71 130.89 381.12 132.06 409.71 126.69 409.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.42,379.25c.14,0-.93,7.11-2.39,15.82s-2.75,15.76-2.9,15.74.93-7.11,2.39-15.82S88.28,379.23,88.42,379.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,347.85a5.57,5.57,0,1,1-5.57-5.57A5.56,5.56,0,0,1,115.39,347.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,353.44a5.59,5.59,0,1,1,5.59-5.59A5.6,5.6,0,0,1,109.82,353.44Zm0-11.13a5.54,5.54,0,1,0,5.54,5.54A5.55,5.55,0,0,0,109.82,342.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.41,328.44s2.62-3.7,1.73-7.81h0s0-1.33-2-3.94A14.58,14.58,0,0,0,65,314.42a15.9,15.9,0,0,0-2.27-1.65c-.27-.17-.44-.26-.44-.26h0a13.7,13.7,0,0,0-9.68-1.45A12.62,12.62,0,0,0,46,314.73a9.74,9.74,0,0,0-1.51,2.07A14.53,14.53,0,0,0,43,328.4c.08.26.17.52.27.77l0,.09c0,.09.07.18.11.26l.08.18c.09.21.17.41.27.61a13.88,13.88,0,0,0,.82,1.45,7.41,7.41,0,0,0,1.11,1.51h0a7.74,7.74,0,0,0,6.84,2.7,4.37,4.37,0,0,0,2.33,2c1.93.44,5.07-.53,7.35-1.75s5.55-3.55,5.5-5.54a9.45,9.45,0,0,0-.35-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.45,311.06a12.55,12.55,0,0,0-6.55,3.67,9.78,9.78,0,0,0-1.52,2.07c-1.33,2.56-3.62,7.49-.69,13.51s7.27,5.87,9.23,5.59,14.38-7.46,14.38-7.46,3.8-5.35.71-10.33C63.36,313.85,57.68,309.51,50.45,311.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.54,334.23s1.34,3.28,3.27,3.71,5.06-.53,7.34-1.75,5.55-3.55,5.5-5.54-1-4.2-1.33-4.38a11.49,11.49,0,0,0-9.18,1.45A12.19,12.19,0,0,0,49.54,334.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.26,315.25a6.6,6.6,0,1,1-8.95-2.68A6.6,6.6,0,0,1,56.26,315.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.62,333.27a8.39,8.39,0,0,0,.44-5.89,8.19,8.19,0,0,0-3.67-4.51,16,16,0,0,0,1,6.65A12.13,12.13,0,0,0,43.62,333.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.06,320.64a8.44,8.44,0,0,1-5.16-2.87,7.47,7.47,0,0,1-1.77-5.26,18.26,18.26,0,0,1,4.94,4.19C67.05,319.32,67.06,320.64,67.06,320.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.56,334.19a2.18,2.18,0,0,0,.24.76.67.67,0,0,0,.68.33c.29-.07.45-.35.58-.61a15.49,15.49,0,0,1,6.07-6.23,7.65,7.65,0,0,1,3.38-1.09c1.08,0,2.13.27,3.21.33a1.59,1.59,0,0,0,.81-.12c.24-.12.23-.4.17-.66a.93.93,0,0,0-.38-.63c-2.84-1.17-6.36-.31-9,1.22a15,15,0,0,0-5.75,6.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.27,
    y: 425.81,
    width: 96.61,
    height: 6.81,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16,423.19H144a7.76,7.76,0,0,1,7.76,7.76v1.67a0,0,0,0,1,0,0h-20.3a0,0,0,0,1,0,0v-1.67A7.76,7.76,0,0,1,139.16,423.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,430.5a93.38,93.38,0,0,1-9.78.26,93.5,93.5,0,0,1-9.79-.26,90.33,90.33,0,0,1,9.79-.26A90.21,90.21,0,0,1,151.41,430.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,423.11a12.28,12.28,0,0,1,.17,3.59,12.83,12.83,0,0,1-.36,3.57,12.5,12.5,0,0,1-.16-3.58A12.94,12.94,0,0,1,141.78,423.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.71,
    y: 432.62,
    width: 464.59,
    height: 13.52,
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingPana);
export default __webpack_public_path__ + "static/media/Coding-pana.b9776292d59dc7bd56ceb78aebe35bbd.svg";
export { ForwardRef as ReactComponent };